export const HERO_BADGE = "PARTNER INFRASTRUCTURE · WHITE-LABEL READY";

export const HERO_HEADLINE = "Scale Your Agency's MRR. Not Your Payroll.";

export const HERO_SUB =
  "Deploy white-label AI Employees with 100+ conversations per client slot. Add $300+ of pure monthly margin without hiring a single account manager.";

export const HERO_STATS = [
  { value: "9 sec", label: "Lead Capture" },
  { value: "$300+", label: "Margin / Client" },
  { value: "72h", label: "Deploy Time" },
];
